export default __webpack_public_path__ + "static/media/product-3.1227e4e5.jpg";